var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col max-h-screen" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "h-full p-4 overflow-y-auto shadow-inner" },
      [
        _c("todays-date-button-component", {
          staticClass: "mb-2",
          attrs: {
            "data-cy": "wingsCompletionDate",
            label: "Wings",
            alignment: "top",
          },
          model: {
            value: _vm.student.officerTrainingSchoolWingscompletiondate,
            callback: function ($$v) {
              _vm.$set(
                _vm.student,
                "officerTrainingSchoolWingscompletiondate",
                $$v
              )
            },
            expression: "student.officerTrainingSchoolWingscompletiondate",
          },
        }),
        _c("todays-date-button-component", {
          staticClass: "mb-2",
          attrs: { "data-cy": "gtcMcCompletionDate", label: "GTC MC" },
          model: {
            value: _vm.student.officerTrainingSchoolGtcmccompletiondate,
            callback: function ($$v) {
              _vm.$set(
                _vm.student,
                "officerTrainingSchoolGtcmccompletiondate",
                $$v
              )
            },
            expression: "student.officerTrainingSchoolGtcmccompletiondate",
          },
        }),
        _c("todays-date-button-component", {
          staticClass: "mb-2",
          attrs: { "data-cy": "promoteCompletionDate", label: "Promote" },
          model: {
            value: _vm.student.officerTrainingSchoolPromotecompletiondate,
            callback: function ($$v) {
              _vm.$set(
                _vm.student,
                "officerTrainingSchoolPromotecompletiondate",
                $$v
              )
            },
            expression: "student.officerTrainingSchoolPromotecompletiondate",
          },
        }),
        _c("todays-date-button-component", {
          staticClass: "mb-2",
          attrs: { "data-cy": "sf600RosterDate", label: "SF600 Roster" },
          model: {
            value: _vm.student.officerTrainingSchoolSf600rosterdate,
            callback: function ($$v) {
              _vm.$set(_vm.student, "officerTrainingSchoolSf600rosterdate", $$v)
            },
            expression: "student.officerTrainingSchoolSf600rosterdate",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-shrink-0 p-4 border-b" }, [
      _c("div", { staticClass: "font-semibold" }, [_vm._v("Before OTS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }